export { default as NavBar } from "./nav";
export { default as Footer } from "./footer";
export { default as DropDown } from "./dropdownMenu";
export { default as GenreNav } from "./genreNav";
